export default "__VITE_ASSET__CFcVfykc__"